import { RouteObject } from 'react-router-dom';
import { loader as StatsLoader } from "../pages/Stats";
import HomeStatsResponsive from "../components/ResponsiveWrapper/Stats/HomeStatsResponsive";
import StatsForumResponsive from "../components/ResponsiveWrapper/Stats/StatsForumResponsive";
import BestWrestlerResponsive from "../components/ResponsiveWrapper/Stats/BestWrestlerResponsive";
import { BestWrestlerResponsiveLoader } from "../loaders/BestWrestlerResponsiveLoader";
import BestFemaleWrestlerResposive from "../components/ResponsiveWrapper/Stats/BestFemaleWrestlerResposive";
import { BestWomansWrestlerResposiveLoader } from "../loaders/StatsLoaderExceptBestWrestler.js/BestWomansWrestlerResposiveLoader";
import MostWinsWrestlerResponsive from "../components/ResponsiveWrapper/Stats/MostWinsWrestlerResponsive";
import { MostWinsResponsiveLoader } from "../loaders/StatsLoaderExceptBestWrestler.js/MostWinsResponsiveLoader";
import MostWinsWrestlerFemaleResponsive from "../components/ResponsiveWrapper/Stats/MostWinsFemaleResponsive";
import { MostWinsFemaleResponsiveLoader } from "../loaders/StatsLoaderExceptBestWrestler.js/MostWinsFemaleResponsiveLoader";
import MostFightsWrestlerResponsive from "../components/ResponsiveWrapper/Stats/MostFightsWrestlerResponsive";
import { MostFightsResponsiveLoader } from "../loaders/StatsLoaderExceptBestWrestler.js/MostFightsResponsiveLoader";
import MostFightsWrestlerFemaleMobile from "../pages/Mobile/Stats/MostFightsFemaleMobile";
import { MostFightsFemaleResponsiveLoader } from "../loaders/StatsLoaderExceptBestWrestler.js/MostFightsFemaleResponsiveLoader";

export const statsRoutes: RouteObject = {
  path: 'stats',
  children: [
    {
      index: true,
      element: <HomeStatsResponsive />,
      loader: StatsLoader
    },
    {
      path: 'stats-forum',
      element: <StatsForumResponsive />,
    },
    {
      path: 'best-wrestler',
      element: <BestWrestlerResponsive />,
      loader: BestWrestlerResponsiveLoader
    },
    {
      path: 'best-wrestler-woman',
      element: <BestFemaleWrestlerResposive />,
      loader: BestWomansWrestlerResposiveLoader
    },
    {
      path: 'most-wins-wrestler',
      element: <MostWinsWrestlerResponsive />,
      loader: MostWinsResponsiveLoader
    },
    {
      path: 'most-wins-wrestler-woman',
      element: <MostWinsWrestlerFemaleResponsive />,
      loader: MostWinsFemaleResponsiveLoader
    },
    {
      path: 'most-matches-wrestler',
      element: <MostFightsWrestlerResponsive />,
      loader: MostFightsResponsiveLoader
    },
    {
      path: 'most-matches-wrestler-woman',
      element: <MostFightsWrestlerFemaleMobile />,
      loader: MostFightsFemaleResponsiveLoader
    }
  ]
};
